import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Typography } from '@mui/material';

import { setPageMainTitle } from '../../utils/Helpers';
import messages from '../../assets/locale/messages';
import { getProvidersLookupRequest, getProvidersLookupResponse } from '../../store/LookUps/actions'
import { getBranchesRequest } from '../../store/Branches/actions';
import SearchInput from '../../components/SearchInput';
import FilterLabel from '../../components/Filter/FilterLabel';
import FilterInput from '../../components/Filter/FilterInput';
import EmptyState from '../../components/EmptyState';
import Pagination from '../../components/Pagination';
import PublishRequestCard from './PublishRequestCard'
import './PublishRequests.scss'

const PublishRequests = () => {
    const dispatch = useDispatch();
    const isLoading = useSelector((state) => state.loader);
    const lang = useSelector((state) => state.locale.lang);
    const listOfProviders = useSelector((state) => state.lookUps.providers);
    const list = useSelector((state) => state.branches.list);
    const meta = useSelector((state) => state.branches.meta);
    const requestStatus = useSelector((state) => state.branches.requestStatus);
    const { publishRequests, pagesTitles, shared } = messages[lang];
    const [page, setPage] = useState(1);
    const [searchValue, setSearchValue] = useState('');
    const [filterProviderValue, setFilterProviderValue] = useState(null);
    const [providerOptions, setProviderOptions] = useState([]);
    
    useEffect(() => {
        setPageMainTitle('branchManagement');
    }, []);

    useEffect( () => {
        return( ()=>{
            dispatch(getProvidersLookupResponse([]));
        })
    },[])

    useEffect(() => {
        dispatch(getProvidersLookupRequest({page:-1}));
    },[lang])

    useEffect(() => {
        if (listOfProviders !== null) {
                setProviderOptions(
                    listOfProviders.map(({ id, name_en, name_ar }) => ({
                        id: id,
                        label: lang === 'en' ? name_en : name_ar,
                    }))
                );
        }
    }, [listOfProviders, lang]);

    useEffect(() => {
        if (filterProviderValue)
          setFilterProviderValue(providerOptions.find((option) => option.id === filterProviderValue.id));
      }, [ lang, providerOptions]);

    useEffect(() => {
        getPublishRequests(
            page,
            searchValue,
            filterProviderValue
        )
    }, [requestStatus]);

    useEffect(() => {
        getPublishRequests(
            page,
            searchValue,
            filterProviderValue
        )
    }, [page]);

    useEffect(() => {
        getPublishRequests(
            page,
            searchValue,
            filterProviderValue
        )
    }, [searchValue]);

    useEffect(() => {
        getPublishRequests(
            page,
            searchValue,
            filterProviderValue
        )
    }, [filterProviderValue]);

    const getPublishRequests = (
        pageNo,
        search,
        serviceProvider
    ) => {
        dispatch(getBranchesRequest({
            page: pageNo,
            items:10,
            status: 'requested_publishing',
            query: search,
            service_provider_id: serviceProvider?.id
        }))
    }

    const renderHeaderSection = (showActions) => (
        <>
            <div className="mb-4">
                <div className="title-search d-flex justify-content-between flex-column flex-lg-row flew-wrap flex-md-nowrap">
                    <div className='d-flex flex-column flex-md-row gap-2 w-100 mb-2 mb-md-0'>
                        <Typography
                            variant="h4"
                            sx={{ flexGrow: 1 }}
                            className={`page-title flex-grow-0 ${lang === 'en' ? 'me-3' : 'ms-3'}`}>
                            {pagesTitles.publishRequests}
                        </Typography>
                        {showActions && (
                            <SearchInput
                                className="filter-label-wrapper"
                                placeholder={publishRequests.list.search}
                                name="search"
                                value={searchValue}
                                onChange={(value) => {
                                    setSearchValue(value);
                                }}
                            />)
                        }
                    </div>  
                    {showActions && ( 
                        <div className= 'd-flex justify-content-end filter-container w-100' >
                            <div className="mt-2">
                                <FilterLabel />
                            </div>
                            <FilterInput
                                placeholder={publishRequests.list.providerFilterPlaceHolder}
                                options={providerOptions}
                                value={filterProviderValue}
                                name="Service Provider Filter"
                                onChange={(value) => {
                                    setFilterProviderValue(value);
                                }}
                                filterWrapperClass="w-100"
                            />
                        </div>)
                    }
                </div>
            </div>
        </>
    )

    const renderPublishRequestsList = () => {
        if (
            !isLoading &&
            list?.length === 0 &&
            !searchValue &&
            filterProviderValue === null   
           ){
            return (
              <>
                {renderHeaderSection(false)}
                <div className="bg-white rounded-4 categoriess-page d-flex justify-content-center align-items-center flex-column">
                  <EmptyState
                    subTitle={publishRequests.list.noData}
                    showActionButton={false}
                    NoDataListWithNoActionBtn={true}
                  />
                </div>
              </>
            );
        } else if (
            !isLoading &&
            (searchValue ||
             filterProviderValue != null) &&
            list?.length === 0
          ) {
            return (
              <>
                {renderHeaderSection(true)}
                <div className="bg-white rounded-4 categoriess-page d-flex justify-content-center align-items-center flex-column  mt-3">
                  <EmptyState subTitle={shared.noSearch} showActionButton={false} />
                </div>
              </>
            );
        }else {
            return (
                <>
                    {renderHeaderSection(true)}
                    {list?.map(request => (
                        <PublishRequestCard 
                            branchName = {lang === 'en' ? request.name_en : request.name_ar }
                            branchId = {request.id}
                            branchLocation = {request.offered_location ==='in_place' ? 
                                                request.building_number +' '+ request.street + ', '+ request.region + ', '+ request.city : 
                                                publishRequests.list.home
                                             }
                            providerName = {lang === 'en' ? request.service_provider.name_en : request.service_provider.name_ar }
                        />
                    ))}
                    <div className="d-flex justify-content-center py-3">
                        {meta?.pages > 1 && (
                            <Pagination
                                count={meta?.pages}
                                page={meta?.currentPage || page}
                                handleChange={(event, page) => {
                                    setPage(page);
                                 }}
                                defaultPage={1}
                            />
                        )}
                    </div>
                </>
            )
        }
    }
    
    return(renderPublishRequestsList());
}

export default PublishRequests;